import { Input } from 'antd';
import { styled } from 'styled-components';

export const StyledMoreDiv = styled.div`
  .up-arrow-icon {
    background: url('//static.szlcsc.com/ecp/assets/web/page/www/get-coupons/images/arrow.svg') no-repeat center center;
    background-size: 100% 100%;
  }
  &:hover {
    .up-arrow-icon {
      background: url('//static.szlcsc.com/ecp/assets/web/page/www/get-coupons/images/arrow-a.svg') no-repeat center
        center;
      background-size: 100% 100%;
    }
  }
`;

export const StyledSearchInput = styled(Input)`
  .search-icon {
    background: url('//static.szlcsc.com/ecp/assets/web/page/www/get-coupons/images/search.svg') no-repeat center center;
    background-size: 100% 100%;
  }
  &:hover {
    .search-icon {
      background: url('//static.szlcsc.com/ecp/assets/web/page/www/get-coupons/images/search-a.svg') no-repeat center
        center;
      background-size: 100% 100%;
    }
  }
`;

export const StyledFilterCondition = styled.div`
  .up-icon {
    background: url('//static.szlcsc.com/ecp/assets/newWeb/www/lingquan/lq-sort-arrow.svg') no-repeat center center;
  }
  .up-icon-a {
    background: url('//static.szlcsc.com/ecp/assets/newWeb/www/lingquan/lq-sort-arrow-active.svg') no-repeat center
      center;
  }
  .down-icon {
    background: url('//static.szlcsc.com/ecp/assets/newWeb/www/lingquan/lq-sort-arrow.svg') no-repeat center center;
    transform: rotate(180deg);
  }
  .down-icon-a {
    background: url('//static.szlcsc.com/ecp/assets/newWeb/www/lingquan/lq-sort-arrow-active.svg') no-repeat center
      center;
    transform: rotate(180deg);
  }
`;

export const StyledCouponCardLi = styled.li`
  background: url('//static.szlcsc.com/ecp/assets/newWeb/www/lingquan/lq-yhq-bg.svg') no-repeat center center;
  background-size: 100% 100%;
  &.lq-hover-1:hover {
    background: url('//static.szlcsc.com/ecp/assets/newWeb/www/lingquan/lq-hover-1.svg') no-repeat center center;
    background-size: 100% 100%;
    -webkit-filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.12));
    filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.12));
  }
  &.lq-hover-2:hover {
    background: url('//static.szlcsc.com/ecp/assets/newWeb/www/lingquan/lq-hover-2.svg') no-repeat center center;
    background-size: 100% 100%;
    -webkit-filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.12));
    filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.12));
  }
  &.lq-hover-3:hover {
    background: url('//static.szlcsc.com/ecp/assets/newWeb/www/lingquan/lq-hover-3.svg') no-repeat center center;
    background-size: 100% 100%;
    -webkit-filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.12));
    filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.12));
  }
  &.has-lw {
    background: url('//static.szlcsc.com/ecp/assets/newWeb/www/lingquan/lq-has-receive-all.svg') no-repeat center center;
    background-size: 100% 100%;
  }
  &.has-sx {
    background: url('//static.szlcsc.com/ecp/assets/newWeb/www/lingquan/lq-sx-bg.svg') no-repeat center center;
    background-size: 100% 100%;
  }
  &.has-use {
    background: url('//static.szlcsc.com/ecp/assets/newWeb/www/lingquan/lq-has-use-bg.svg') no-repeat center center;
    background-size: 100% 100%;
  }
`;

export const StyledCouponBagLi = styled.li`
  background: url('//static.szlcsc.com/ecp/assets/newWeb/www/lingquan/lq-qb-bg-2.svg') no-repeat center center;
  &.has-buy {
    background: url('//static.szlcsc.com/ecp/assets/newWeb/www/lingquan/lq-qb-has-buy-2.svg') no-repeat center center;
  }
  &.has-sale {
    background: url('//static.szlcsc.com/ecp/assets/newWeb/www/lingquan/lq-qb-has-sale-2.svg') no-repeat center center;
  }
`;

export const StyledScrollUl = styled.ul`
  scrollbar-width: thin;
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background-color: #e2e8f0;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
  }
  &::-webkit-scrollbar-button {
    display: none;
  }
`;

export const StyledSection = styled.section`
  & {
    transition: top 0.2s ease;
  }
  &.start {
    top: 270px;
  }
  &:not(.start) {
    top: 390px;
  }
`;
